module.exports = __webpack_public_path__ + "static/img/03-apps.2100ff3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lti-setup-guide/03-apps.png
// module id = NDj5
// module chunks = 1